import React, { useState, useEffect } from 'react';
import './ScrollButton.css';

const ScrollButton = ({ showPracticeButton = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrolled = document.documentElement.scrollTop;
      
      // Mostrar el botón después de hacer scroll hacia abajo
      if (scrolled > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  const scrollToPractice = () => {
    // Buscar la sección de quiz/práctica en orden de prioridad
    const selectors = [
      '.quiz-section',           // Sección de quiz principal
      '[class*="quiz"]',         // Cualquier elemento con "quiz" en la clase
      '[class*="practice"]',     // Sección de práctica
      '[class*="trivia"]',       // Sección de trivia
      '[id*="quiz"]',            // ID que contenga "quiz"
      '[id*="practice"]',        // ID que contenga "practice"
      'section:has(.quiz)',      // Sección que contenga quiz
      '.english-content',        // Contenido de inglés como fallback
    ];
    
    for (const selector of selectors) {
      try {
        const element = document.querySelector(selector);
        if (element) {
          // Calcular offset para mejor posicionamiento
          const elementRect = element.getBoundingClientRect();
          const elementTop = elementRect.top + window.scrollY - 80; // 80px de offset
          
          window.scrollTo({
            top: elementTop,
            behavior: 'smooth'
          });
          
          // Agregar un efecto visual temporal al elemento encontrado
          element.style.outline = '3px solid #10b981';
          element.style.outlineOffset = '4px';
          setTimeout(() => {
            element.style.outline = '';
            element.style.outlineOffset = '';
          }, 2000);
          
          return; // Salir del bucle cuando encuentre el elemento
        }
      } catch (error) {
        // Continuar con el siguiente selector si hay error
        continue;
      }
    }
    
    // Si no encuentra ninguna sección de práctica, mostrar mensaje
    console.log('No se encontró sección de práctica');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="scroll-button-container">
      <button
        className="scroll-button scroll-up"
        onClick={scrollToTop}
        title="Ir arriba"
      >
        <span className="scroll-icon">↑</span>
      </button>
      
      {showPracticeButton && (
        <button
          className="scroll-button scroll-practice"
          onClick={scrollToPractice}
          title="Ir a práctica"
        >
          <span className="scroll-icon practice-icon">🤖</span>
        </button>
      )}
      
      <button
        className="scroll-button scroll-down"
        onClick={scrollToBottom}
        title="Ir abajo"
      >
        <span className="scroll-icon">↓</span>
      </button>
    </div>
  );
};

export default ScrollButton;
